export const detectZoom = () => {
  let ratio = 1;
  const screen = window.screen;
  const ua = navigator.userAgent.toLowerCase();

  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (ua.indexOf('msie') !== -1 && screen.deviceXDPI && screen.logicalXDPI) {
    ratio = screen.deviceXDPI / screen.logicalXDPI;
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth;
  }

  return Math.round(ratio * 100);
};
export const applyResponsiveScaling = () => {
  const zoomLevel = detectZoom();
  const screenWidth = window.screen.width * window.devicePixelRatio;
  const baseWidth = 1920;

  let zoomFactor;
  let widthFactor;

  if (screenWidth !== baseWidth) {
    zoomFactor = screenWidth / baseWidth;
    widthFactor = baseWidth / screenWidth;
  } else {
    zoomFactor = 1;
    widthFactor = 1;
  }

  // 检测是否支持 zoom 属性
  const supportsZoom = 'zoom' in document.body.style;

  if (supportsZoom) {
    document.body.style.zoom = (100 / zoomLevel) * zoomFactor;
    document.body.style.overflowX = 'hidden'; // 隐藏滚动条
  } else {
    // 对于不支持 zoom 的浏览器，如 Firefox，使用 transform: scale
    document.body.style.transform = `scale(${(100 / zoomLevel) * zoomFactor})`;
    document.body.style.transformOrigin = 'top left';
    document.body.style.overflow = 'hidden'; // 隐藏滚动条
  }

  document.body.style.width = (zoomLevel * widthFactor) + "vw";
  document.body.style.height = (zoomLevel * widthFactor) + "vh";
};



// WEBPACK FOOTER //
// ./src/unitls/detectZoom.js